var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.knowledge-base-jumbotron-content{\n  background-image:url(" + escape(require("../../assets/images/pages/knowledge-base-cover.jpg")) + ");\n  background-size:cover\n}", ""]);

// exports
